import React from 'react';
import { text as textById } from './Text';
import { EContext } from '../EContext';
import routeTextsMap from '../../../../utilities/routeTextsMap';

export const text = translations => (placeholder: React.ReactNode, route: string, replacements?: object) =>
    textById(translations)(placeholder, routeTextsMap[route], replacements);

interface Props {
    children: React.ReactNode;
    route: string;
    replacements?: object;
}

export default function TextByRoute({ children, route, replacements }: Props) {
    const { texts } = React.useContext(EContext);
    return text(texts)(children, route, replacements);
}
